// @flow
import { media } from '~/core/utils/style';
import styled from 'styled-components';
import SVGIcon from '~/core/icons/svg-icons';

export const HubClockContainer = styled.div`
    align-items: center;
    display: flex;
    font-size: 1rem;
    justify-content: flex-end;
    padding: 0 1em;
`;

export const HomeIcon = styled(SVGIcon)`
    height: 1.3rem;
    margin-bottom: 0.3rem;
    margin-right: 0.4rem;
    width: 1.3rem;
`;

export const HubClockLongTimeSpan = styled.span`
    display: none;

    ${media.tablet`
		display: inherit;
	`};
`;

export const HubClockShortTimeSpan = styled.span`
    display: inherit;

    ${media.tablet`
		display: none;
	`};
`;



// WEBPACK FOOTER //
// ./src/components/widgets/hub-clock/styles.js